import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { DocumentDetailPage } from "@components/main/documentManagement";

const DocumentDetailPageContainer: FC = () => {
  const { fileId } = useParams();

  if (!fileId) {
    return null;
  }

  return <DocumentDetailPage fileId={fileId} />;
};

export default DocumentDetailPageContainer;
